import { render, staticRenderFns } from "./OfertasGlobais.vue?vue&type=template&id=af5a836a"
import script from "./OfertasGlobais.vue?vue&type=script&lang=js"
export * from "./OfertasGlobais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af5a836a')) {
      api.createRecord('af5a836a', component.options)
    } else {
      api.reload('af5a836a', component.options)
    }
    module.hot.accept("./OfertasGlobais.vue?vue&type=template&id=af5a836a", function () {
      api.rerender('af5a836a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OfertasGlobais.vue"
export default component.exports